import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { GetProjectsResponse, ProjectResponse } from "api/generatedApi";
import DialogTitleStyled from "components/shared/dialog/dialog-title-styled";
import { usePaperProps } from "components/shared/dialog/paper-props";
import { useTranslation } from "react-i18next";
import type { DialogBaseProps } from "shared/dialog/types";
import { ProjectsItem } from "./components/projects-item";
import { useState } from "react";
import { ExtendedProjectFolder } from "pages/project/hooks/use-map-tree-to-flat";
import { Box, Typography } from "@mui/material";

interface Props extends DialogBaseProps {
  onSubmit: (project: ProjectResponse, dataFlatlist: ExtendedProjectFolder[], crossProjectCopy: boolean) => Promise<void>;
  projects: ProjectResponse[];
  sourceProject: ProjectResponse;
}

export const ChooseProject = (props: Props) => {
  const { t } = useTranslation();
  const { paperProps } = usePaperProps();
  const { projects, sourceProject } = props;
  const [dataFlatList, setDataFlatList] = useState<ExtendedProjectFolder[] | undefined>();
  const [selectedProject, setSelectedProject] = useState<ProjectResponse | undefined>();

  const handleClick = (project: ProjectResponse, dataFlatlist: ExtendedProjectFolder[]) => {
    setSelectedProject(project);
    setDataFlatList(dataFlatlist);
    setCrossProjectCopy(project.projectId !== props.sourceProject?.projectId);
  };

  const otherProjects = projects.filter((project) => project.projectId !== props.sourceProject?.projectId);
  const finalProjectsList = [sourceProject, ...otherProjects];
  const [crossProjectCopy, setCrossProjectCopy] = useState(false);

  return (
    <Dialog maxWidth="sm" open={props.isOpen} PaperProps={paperProps}>
      <DialogTitleStyled title={t("folder.copy.title")} description={t("folder.copy.projectsDescription")} onClose={props.onClose} isOpen={props.isOpen} />
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", overflowY: "auto", maxHeight: "400px" }}>
          {finalProjectsList.length > 0 ? (
            finalProjectsList.map((project: ProjectResponse) => <ProjectsItem key={project.projectId} isSelected={selectedProject?.projectId === project.projectId} project={project} onSubmit={handleClick} />)
          ) : (
            <Typography>{t("folder.copy.noProjectsWithPermission")}</Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={props.onClose}>
          {t("common.cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectedProject || !dataFlatList}
          onClick={() => {
            if (selectedProject && dataFlatList) {
              props.onSubmit(selectedProject, dataFlatList, crossProjectCopy);
            }
          }}
        >
          {t("folder.copy.copyToProject")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
